import type { IconName } from '@kiips/ui';

/**
 * The three Journey modes TravelPayouts aggregates under one partner
 * (Omio) — see ADR-0066.
 *
 * Lives here rather than in either call site because two surfaces build
 * Omio CTAs and were carrying byte-identical copies of this map: the add
 * sheet (`affiliate-choice-ctas.ts`) and the journey detail screen
 * (`AffiliateSearchButton.tsx`). A new rail sub-mode should be one edit,
 * not two.
 *
 * Labels are deliberately *not* shared: the add sheet offers "Trains"
 * (you don't have one yet), the detail screen "Find this train" (you do).
 */
export type RailMode = 'train' | 'bus' | 'ferry';

export const RAIL_ICONS: Record<RailMode, IconName> = {
  train: 'train',
  bus: 'directions-bus',
  ferry: 'directions-boat',
};
